import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut'])

export const contentComputed = {
  ...mapState('content', {
    social: (state) => state.social,
    banners: (state) => state.banners,
    options: (state) => state.options,
    features: (state) => state.features,
    info: (state) => state.info,
  }),
  ...mapGetters('content', ['menuOptions']),
}

export const contentMethods = mapActions('content', ['submit'])
